module.exports = __webpack_public_path__ + "templates/sellerSearch.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/core/components/sellerSearch/sellerSearch.html
// module id = 287
// module chunks = 15